export default {
    "menu":[
        {
            "header":"Tasks",
            "key":"assignment",
            "opened": false,
            "items":[
                {
                    "title": "All Tasks",
                    "link": "/tasks",
                    "key": "tasks"
                },
                {
                    "title": "My Tasks",
                    "link": "/tasks/my",
                    "key": "tasks-my"
                },
                {
                    "title": "Create Task",
                    "link": "/tasks/create",
                    "key": "tasks-create"
                }
            ]
        },
        {
            "header":"Assets",
            "key":"web",
            "opened": false,
            "items":[
                {
                    "title": "Catalog",
                    "link": "/asset",
                    "key": "asset"
                },
                {
                    "title": "Categories",
                    "link": "/asset/categories",
                    "key": "asset-categories"
                },
                {
                    "title": "Depot",
                    "link": "/asset/depot",
                    "key": "asset-depot"
                }
            ]
        },
        {
            "header":"Products",
            "key":"inventory",
            "opened": false,
            "items":[
                {
                    "title": "Product Catalog",
                    "link": "/products",
                    "key": "products"
                },
                {
                    "title": "Product Organization",
                    "link": "/organization/management/areas"
                }
            ]
        },
        {
            "header":"Counts",
            "key":"app_settings_alt",
            "opened": false,
            "items":[
                {
                    "title": "Counts",
                    "link": "/counts/basic",
                    "key": "inventoryCountsBasic"
                },
                {
                    "title": "Count History",
                    "link": "/counts",
                    "key": "inventoryCounts"
                },
                {
                    "title": "Finalized Counts",
                    "link": "/counts/finalized",
                    "key": "inventoryFinalized"
                }
            ]
        },
        {
            "header":"Administration",
            "key":"settings_suggest",
            "opened": false,
            "items":[
                {
                    "title": "Users",
                    "link":"/users",
                    "key": "users"
                }
            ]
        },
        {
            "header":"settings",
            "key":"settings",
            "opened": false,
            "items":[

            ]
        }


    ]
}